import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { FlowNodeTypes, } from 'components/powerFlowShared/components/types';
import { hasFeature } from 'components/shared/featureFlag';
import { withRouter } from 'hocs/router';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
import { selectSortedQueuesByName } from '../../../app/utils/reselect';
import { notificationActions } from '../../notifications/actions/notification';
import { getAllQueues } from '../../settings/actions/queues';
import { emailFlowActions } from '../actions/emailFlowActions';
import PowerEmailFlow from '../components/PowerEmailFlow';
const { notificationAdd } = notificationActions;
const { emailFlowGet, emailFlowEdit, emailFlowResetState } = emailFlowActions;
const getId = (_state, ownProps) => {
    return ownProps.params.flowId;
};
const contentRuleTypeToRuleVariableT = (type) => {
    return {
        type: 'system',
        id: type === 'from' ? 'from_email' : type,
    };
};
const contentRuleRuleToMatchingOperator = (rule) => {
    return rule;
};
const contentRuleMatchToMatchingRule = (match) => {
    return {
        id: '',
        type: 'input',
        value: match,
    };
};
const convertContentToBranchNode = (node) => {
    const { payload } = node;
    return Object.assign(Object.assign({}, node), { nodeType: FlowNodeTypes.FILTERS, payload: {
            match_node_id: payload.match_node_id,
            non_match_node_id: payload.non_match_node_id,
            matching_strategy: payload.rule_type,
            rules: payload.rules.map((rule) => {
                return {
                    variable: contentRuleTypeToRuleVariableT(rule.type),
                    matching_rule: contentRuleRuleToMatchingOperator(rule.rule),
                    match: contentRuleMatchToMatchingRule(rule.match),
                };
            }),
        } });
};
const convertContentToBranchNodes = (nodes) => {
    if (nodes === null)
        return nodes;
    const labelFix = {};
    return nodes
        .map((node) => {
        if (node.nodeType === FlowNodeTypes.CONTENT) {
            if (typeof node.payload.non_match_node_id === 'string') {
                labelFix[node.payload.non_match_node_id] = 'No match';
            }
            return convertContentToBranchNode(node);
        }
        return node;
    })
        .map((node) => {
        if (labelFix[node.id]) {
            return Object.assign(Object.assign({}, node), { connectionLabel: labelFix[node.id] });
        }
        return node;
    });
};
const getNodes = (state) => convertContentToBranchNodes(state.emailFlow.nodes);
const getFlowName = (state) => state.emailFlow.name;
const selectFlowData = createSelector([getId, getNodes, getFlowName], (id, nodes, name) => {
    return {
        actions: nodes !== null && nodes !== void 0 ? nodes : [],
        active: true,
        created_at: '',
        id: id !== null && id !== void 0 ? id : '',
        name,
        updated_at: '',
    };
});
const mapStateToProps = (state, ownProps) => {
    return {
        email_address: state.emailFlow.email_address,
        email_id: state.emailFlow.email_id,
        flowData: selectFlowData(state, ownProps),
        id: ownProps.params.flowId,
        isCanvasEnabled: hasFeature(state, 'routing-use-canvas'),
        isIntegrationsEnabled: hasFeature(state, 'integrations-for-email'),
        nodes: state.emailFlow.nodes,
        queuesState: selectSortedQueuesByName(state),
        status: state.emailFlow.meta.asyncStatus,
        agentDisplayName: state.settings.profile.profile.name,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchFlow: bindActionToPromise(dispatch, emailFlowGet),
        getAllQueues: () => dispatch(getAllQueues()),
        notificationAdd: (payload) => dispatch(notificationAdd(payload)),
        resetState: () => dispatch(emailFlowResetState()),
        updateFlow: bindActionToPromise(dispatch, emailFlowEdit),
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PowerEmailFlow));
